var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 170,
    viewBox: "0 0 256 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 170,
    rx: 8,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.215 98.3125L125.402 102.075H81.9401L82.7539 98.3125H126.215Z",
    fill: "#C5E5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.855 88.6641L119.041 92.4191H82.6113L83.418 88.6641H119.855Z",
    fill: "#C5E5F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.432 56.8867H130.642V59.7423H134.432V56.8867Z",
    fill: "#24293D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.642 56.5312H91.3206V60.1007H130.642V56.5312Z",
    fill: "#24293D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.522 114.713H65.4637V87.8711H69.0332V111.144H140.522V114.713Z",
    fill: "#24293D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.789 114.713H174.16V111.144H195.22V60.1007H180.25V56.5312H198.789V114.713Z",
    fill: "#24293D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8306 45.457L76.5357 53.8595L85.6663 52.8672L80.8833 61.1483L85.6663 67.6875L77.6208 66.8094L72.8306 75.0977L69.1255 66.6952L59.9949 67.6875L64.7851 59.3993L59.9949 52.8672L68.0475 53.7381L72.8306 45.457Z",
    fill: "#C6E4F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6523 78.4023L68.1976 68.3007L57.218 69.4929L62.9934 59.4914L56.7754 51.0032L67.2339 52.1383L73.0092 42.1367L77.4639 52.2382L88.4435 51.0461L82.6681 61.0476L88.8861 69.5358L78.4276 68.4007L72.6523 78.4023ZM70.0537 65.0811L73.0092 71.7845L76.8071 65.2096L82.4468 65.8236L79.0916 61.2404L82.8894 54.6655L75.6078 55.4579L72.6523 48.7545L68.8544 55.3294L63.2147 54.7154L66.5699 59.2986L62.7721 65.8735L70.0537 65.0811Z",
    fill: "#24293D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.654 84.8984L119.84 88.6606H83.4106L84.2173 84.8984H120.654Z",
    fill: "#24293D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.366 75.3281L111.559 79.0903H83.2109L84.0248 75.3281H112.366Z",
    fill: "#24293D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M111.566 79.0898L110.76 82.8449H82.4113L83.2251 79.0898H111.566Z",
    fill: "#C5E5F7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.521 56.5391L101.75 60.0942H88.1865L90.3139 56.5391H102.521Z",
    fill: "#24293D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.463 56.5156L119.241 60.1065H133.954L137.002 56.5156H118.463Z",
    fill: "#24293D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157.341 93.9158C166.63 93.9158 174.16 86.3856 174.16 77.0966C174.16 67.8076 166.63 60.2773 157.341 60.2773C148.052 60.2773 140.521 67.8076 140.521 77.0966C140.521 86.3856 148.052 93.9158 157.341 93.9158Z",
    fill: "#C5E5F7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M157.341 101.789C143.727 101.789 132.648 90.7096 132.648 77.0958C132.648 63.4819 143.727 52.4023 157.341 52.4023C170.955 52.4023 182.035 63.4819 182.035 77.0958C182.035 90.7096 170.955 101.789 157.341 101.789ZM157.341 55.9647C145.69 55.9647 136.217 65.4451 136.217 77.0886C136.217 88.7321 145.698 98.2126 157.341 98.2126C168.985 98.2126 178.465 88.7321 178.465 77.0886C178.465 65.4451 168.992 55.9647 157.341 55.9647Z",
    fill: "#24293D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M169.913 128.283L157.341 118.132L144.777 128.283V106.988H148.346V120.809L157.341 113.541L166.343 120.809V105.246H169.913V128.283Z",
    fill: "#24293D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M173.047 68.9414L154.328 87.6953L143.856 77.2225H148.639L154.328 82.9122L168.328 68.9414H173.047Z",
    fill: "#24293D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M144.777 122.557L148.346 121.786V103.868L144.777 101.926V122.557Z",
    fill: "#24293D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M169.905 122.54L166.343 121.769V103.879L169.905 101.938V122.54Z",
    fill: "#24293D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M194.834 56.5312L194.063 60.1007H180.321L177.287 56.5312H194.834Z",
    fill: "#24293D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0332 95.5375L65.4637 94.7665V72.3789L69.0332 80.2959V95.5375Z",
    fill: "#24293D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M127.015 94.5586L126.201 98.3137H82.7396L83.5535 94.5586H127.015Z",
    fill: "#24293D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualify);
export default __webpack_public_path__ + "static/media/qualify.1e88e898f23ddb9299c7abe3cc0767c9.svg";
export { ForwardRef as ReactComponent };